import axios from 'axios';
import { notification } from 'antd';
import { apiConfig, EnumAPIKey } from '@/constant/app';

// import { store } from 'app/store';

const apiAuthen = {
  [EnumAPIKey.API_BASE]: null,
};

const codeMessage: any = {
  200: 'OK',
  201: 'Created',
  202: 'Accepted',
  204: 'No Content',
  400: 'Bad request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  406: 'Not Acceptable',
  410: 'Gone',
  422: 'Unprocessable Entity',
  500: 'Internal Server Error',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
};
const UNAUTHORIZED_ERROR_TEXT = 'Access Token Expired';

const baseAxios = (apiKey: any) => {
  // const accessToken = JSON.parse(localStorage.getItem('auth') || '{}')?.token
  let headers: any = {
    'Content-Type': 'multipart/form-data'
  };

  let axiosInstance = axios.create({
    baseURL: apiConfig[apiKey] || apiConfig[EnumAPIKey.API_BASE],
    headers: headers,
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      if (config.data) {
        const haveFile = Object.values(config.data).some(
          (e: any) => e && e.toString() === '[object File]'
        )
        if (haveFile) {
          config.headers['Content-Type'] = 'multipart/form-data ; charset=UTF-8'
        }
      }

      return config
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      if (typeof response.data?.errorCode === 'number' && response.data?.errorCode != 0) {
        return Promise.reject(response.data)
      }
      if (response.data?.data) {
        return Promise.resolve(response.data?.data);
      }
      return Promise.resolve(response.data);
    },
    handleError,
  );
  return axiosInstance;
}

const showErrMessage = (message: string) => notification.error({ message: <span style={{ whiteSpace: 'pre-wrap' }}>{message}</span> });

const handleError = (error: any) => {
  const status = error.response?.status || 500;

  const stt: number = Object.keys(codeMessage).includes(`${status}`) ? status : 404;
  if (typeof error?.response?.data?.detail_msg === 'string' || error?.response?.data?.detail_msg?.message?.length) {
    if (typeof error?.response?.data?.detail_msg === 'string') {
      showErrMessage(error.response.data.detail_msg.message[0]);
    } else {
      showErrMessage(error.response.data.detail_msg.message[0]);
    }

  } else {
    showErrMessage(codeMessage[stt]);
  }

  if (error.response && error.response.data) {
    return Promise.reject({ ...error.response.data })
  } else {
    return Promise.reject({
      error: true,
      message: 'Error Code 100: No response error from server',
      statusCode:
        error && error.request && error.request.status
          ? error.request.status
          : '1899'
    })
  }
};

export default baseAxios;
